import * as React from "react";
import {
  CellContext,
  ColumnDef,
  createColumnHelper,
  HeaderContext
} from "@tanstack/react-table";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { SelectableDrop } from "src/pages/Admin/CustomersAndUsers/Customer/Users/CustomerUserAssignedDropsTab";

export interface IAssignedDropsTableColumns {
  checkboxAction: (data: SelectableDrop) => void,
  bulkActionButton: (info: HeaderContext<SelectableDrop, unknown>) => React.ReactNode,
  actionButton: (info: CellContext<SelectableDrop, unknown>) => React.ReactNode,
  terminology: ITerminology
  columns?: CustomerUserDropColumnsPicked[]
}

type CustomerUserDropColumnsPicked = keyof AvailableCustomerUserDropsTableColumns;

interface AvailableCustomerUserDropsTableColumns{
  bulkActionCheck: ColumnDef<SelectableDrop, unknown>,
  branchNumber: ColumnDef<SelectableDrop, unknown>,
  branchName: ColumnDef<SelectableDrop, unknown>,
  actions: ColumnDef<SelectableDrop, unknown>,
}

/** columns for drops the are assigned to a user inc selecting feature*/
export const getUserAssignedDropsTableColumns = (params: IAssignedDropsTableColumns) => {
  const customDropColumnHelper = customCreateColumnHelper<SelectableDrop>();
  const dropColumnHelper = createColumnHelper<SelectableDrop>();

  const AllColumns: AvailableCustomerUserDropsTableColumns = {
    bulkActionCheck: customDropColumnHelper.checkboxColumn(dropColumnHelper, {
      enableColumnFilter: false,
      enableSorting: false
    }, "selected", params.checkboxAction, params.bulkActionButton),

    branchNumber: customDropColumnHelper.standardTextColumn(dropColumnHelper, "branchNumber", {
      header: "Delivery Point Number",
      size: 200
    }),
    branchName: customDropColumnHelper.standardTextColumn(dropColumnHelper, "name", { header: "name" }),

    actions: customDropColumnHelper.actionColumn(dropColumnHelper, params.actionButton, {})
  };

  if (params.columns) {
    return params.columns.map(column => AllColumns[ column ]);
  } else {
    return Object.values(AllColumns);
  }
};
